import type { mainCurrencyData, secundaryCurrencyData, openPrice } from './type';

export class forexOperationsService {

    async getUSDPoints(): Promise<mainCurrencyData> {
        const buyPrice : number = Number(this.getRandomNumberInRange(930, 950).toFixed(2));
        
        const sellPrice : number = Number((buyPrice + this.getRandomNumberInRange(0.05, 0.1)).toFixed(2));
        const porcentualChange : string = this.getRandomNumberInRange(-2, 2).toFixed(2).toString();
        const dayVariation : string = this.getRandomNumberInRange(5, 6.55).toFixed(2).toString();

        return {
            alertBuyPrice: buyPrice,
            alertSellPrice: sellPrice,
            porcentualChange: porcentualChange,
            dayVariation: dayVariation,
        };
    }

    async getOpenPrice(): Promise<openPrice>{
        const price : string = this.getRandomNumberInRange(930, 950).toFixed(2).toString();
        const latest : string = this.getRandomNumberInRange(930, 950).toFixed(2).toString();
        const date : string = new Date().toISOString();
        return {
            latestPrice: latest,
            openPrice: price,
            date
        };
    }

    getRandomNumberInRange(min: number, max: number): number {
        return Math.random() * (max - min) + min;
    }

}